<template>
  <div class="notification-icon-with-modal__wrapper">
    <a-notification-icon
      :is-active="isNotificationWindowVisible"
      :notification-count="notificationCount"
      @click="openNotificationsWindow"
    />

    <a-lazy-hydrate when-visible>
      <a-modal-widget
        v-model="isNotificationWindowVisible"
        :activator-selector="$options.consts.HEADER_NOTIFICATIONS_SELECTOR"
        :slot-selector="$options.consts.NOTIFICATIONS_SELECTOR"
        :error-message-on-slot-load-failure="
          $options.consts.NOTIFICATIONS_ERROR_MESSAGE
        "
        :with-tablet-layout="false"
        :right="0"
        :top-offset="modalWidgetTopOffset"
        :scroll-top="-56"
        :show-social-networks="false"
        :scroll-to-top="false"
        :mobile-height="modalMobileHeight"
        class="notification-icon-with-modal__notification-window"
      >
        <a-notifications class="notification-icon-with-modal__notifications" />
      </a-modal-widget>
    </a-lazy-hydrate>
  </div>
</template>

<script>
import { ICON } from 'shared/AIcon/index'
import ANotifications from '../ANotifications/index'
import AModalWidget from 'modals/AModalWidget/index'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import {
  ACTIVATOR_ID,
  ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID
} from 'enums/activator-id'
import ANotificationIcon from '@/components/AHeader/Shared/AHeaderActions/ANotificationIconWithModalWidget/ANotificationIcon/index.vue'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import { HEADER_HEIGHT } from '@/components/AHeader/enums'

export default {
  name: 'ANotificationIconWithModalWidget',
  mixins: [hydrationHelpers],
  components: { ANotificationIcon, ANotifications, AModalWidget },
  props: {
    notificationCount: propValidator([PROP_TYPES.NUMBER], false, 0)
  },
  consts: {
    ICON,
    NOTIFICATIONS_ERROR_MESSAGE:
      'Error loading user notifications. Please try to reopen it.',
    HEADER_NOTIFICATIONS_SELECTOR:
      ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID[ACTIVATOR_ID.HEADER_NOTIFICATIONS],
    NOTIFICATIONS_SELECTOR: '.notifications__wrapper'
  },
  data() {
    return {
      ICON,
      isNotificationWindowVisible: false,
      HEADER_HEIGHT
    }
  },
  computed: {
    modalWidgetTopOffset() {
      return this.$_hydrationHelpers_isLayoutMobile ? HEADER_HEIGHT.MOBILE : 54
    },
    modalMobileHeight() {
      return `calc(100vh - ${HEADER_HEIGHT.MOBILE}px)`
    }
  },
  methods: {
    openNotificationsWindow() {
      if (this.isNotificationWindowVisible) return

      this.isNotificationWindowVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-icon-with-modal__wrapper {
  position: relative;

  .notification-icon-with-modal__notification-window {
    width: 507px;

    @include mobile {
      width: 100%;
      border: none;
      border-radius: 0;
    }
  }

  .notification-icon-with-modal__notifications {
    padding: 32px;
  }
}
</style>
